function Footer({ children }) {
    return (
        <div>
            <footer>
                {children}
            </footer>
        </div>
    )
}

export default Footer
